import React, { Fragment, Component, useEffect, useState } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import useAuth from '../useAuth';

import useRouter from '@vromo/hooks/useRouter';
import { useStore } from '@vromo/mobx-react';
import { loadFontAwesome } from '@vromo/ui/components/FontAwesome';

export default observer(function LoggedIn({ children, startLoading, stopLoading }) {
    const { location } = useRouter();
    const [login] = useAuth();

    const rootStore = useStore('rootStore');
    const { authStore } = rootStore;

    const [redirect, setRedirect] = useState(false);
    const [done, setDone] = useState(false);

    useEffect(() => {
        rootStore.viewStore.filters.jobs.clear();
        rootStore.viewStore.filters.drivers.clear();

        loadFontAwesome();

        if (authStore.authenticated) setDone(true);
        else {
            try {
                login(localStorage.sharedFleetToken).then(loggedIn => {
                    if (!loggedIn) setRedirect(true);
                    else setDone(true);
                });
            } catch (_) {
                setRedirect(true);
            }
        }
    }, []);

    useEffect(() => {
        if (done) stopLoading();
    }, [done]);

    if (redirect) {
        return (
            <Redirect
                to={{
                    pathname: '/login',
                    state: { from: `${location.pathname}${location.search}` }
                }}
            />
        );
    }

    if (done) {
        return <Fragment key={authStore.role.id}>{children}</Fragment>;
    }

    return null;
});
